import * as React from 'react';
export const knabSvg = React.forwardRef(function knabSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#003F5F',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M23.46 16.15c0-.85.5-1.43 1.24-1.43.73 0 1.23.58 1.23 1.41 0 .84-.49 1.41-1.23 1.41-.73 0-1.24-.57-1.24-1.4zm-.19-2.55v-1.96h-1.16c-.15 0-.3.17-.3.32v6.61c0 .18.15.34.3.34h1.16v-.45c.41.38 1.2.57 1.8.57 1.58 0 2.57-1.24 2.57-2.84 0-1.6-1-3.08-2.56-3.08a3.2 3.2 0 0 0-1.8.5v-.01zm-3.85 3.78c-.2.3-.54.5-.9.5-.48 0-.83-.25-.83-.67 0-.41.32-.64.87-.66l.87-.06v.9h-.01zm-.92-4.29c-.87 0-1.61.23-2.1.44-.12.06-.18.23-.12.36l.36 1.16c.28-.17.96-.48 1.66-.48s1.1.3 1.1.88v.11l-1.35.05c-1.02.06-2.08.4-2.08 1.61 0 1.2.98 1.8 1.94 1.8.87 0 1.3-.47 1.54-.7l.03.36c0 .1.1.21.24.21h1.37v-3.05c0-.92-.14-1.72-.58-2.1-.42-.4-1-.63-2-.63v-.02zm-6.62.87h-.01v-.87h-1.44c-.13 0-.25.16-.25.32v5.16c0 .15.12.32.26.32h1.43v-2.67c0-.79.22-1.41.97-1.41.73 0 .85.54.85 1.26v2.5c0 .18.11.34.24.34h1.34v-3.22c0-1.3-.23-2.58-1.82-2.58-.77 0-1.26.39-1.57.87v-.02zm-2.37-.87H7.7a.5.5 0 0 0-.36.16l-1.51 2.02v-3.63h-1.2c-.14 0-.26.17-.26.32v6.63c0 .14.1.32.27.32h1.19v-1.66l.5-.46 1.2 1.9a.5.5 0 0 0 .44.22h1.71l-2.14-3.4 1.98-2.4v-.02z',
      }),
    ),
  );
});
knabSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var knab = {
  category: 'brand',
  colorable: false,
  name: 'knab',
  svg: knabSvg,
};
